<div [formGroup]="fg()">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.authenticationMode.description' | labelsProvider }}
    </div>

    <mat-radio-group [value]="authenticationMode()" (change)="onRadioButtonChange($event.value)">
      <div class="radio-option">
        <mat-radio-button [value]="authenticationModeEnum.invoker">
          {{ 'commonActions.authenticationMode.userContextTitle' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.authenticationMode.userContextDescription' | labelsProvider }}
        </div>
      </div>

      <div class="radio-option">
        <mat-radio-button [value]="authenticationModeEnum.maker">
          {{ 'commonActions.authenticationMode.authorContextTitle' | labelsProvider }}
        </mat-radio-button>
        <div class="radio-description">
          {{ 'commonActions.authenticationMode.authorContextDescription' | labelsProvider }}
        </div>
      </div>
    </mat-radio-group>
  </div>

  <app-autonomous-with-triggers
    [fg]="fg()"
    [(ignoreIfAutonomousWithTriggers)]="ignoreIfAutonomousWithTriggers"
    [labelKey]="getLabelKey()"
  ></app-autonomous-with-triggers>
</div>
